// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Lhgy","col":"styles_col__2fti_"};